import React from 'react';
import Translate from "../../../../../../../../components/Translate";
import TranslateProperty from "../../../../../../../../components/TranslateProperty";
import Input from "../../../../../../../../components-new/form/Input";
import BlueButton from "../../../../../../../../components-new/buttons/BlueButton";
import DestructiveButton from "../../../../../../../../components-new/buttons/DestructiveButton";
import Switch from "../../../../../../../../components-new/form/Switch";
import Tooltip from "../../../../../../../../components-new/general/Tooltip";
import DeleteIcon from "../../../../../../../../assets/icons/DeleteIcon";

/*
 * The categories a conversation can be filed under.
 *
 * They were tinted cards three to a row, each a third of the panel wide with a
 * 10px margin, so the last row ended ragged and a long name overflowed its
 * card. One row per category now, in the box the rest of the app puts a list in.
 */
const Categories = ({
                        categories,
                        newCategory,
                        handleInputChange,
                        handleKeyPress,
                        handleAddCategory,
                        handleDeleteCategory,
                        visibleCategories,
                        toggleCategoryVisibility
                    }) => (
    <div className="stg-page">
        <div className="stg-card">
            <div className="stg-card__head">
                <div>
                    <p className="stg-card__note"><Translate text="categoriesInfo"/></p>
                </div>
            </div>

            <div className="stg-add-row">
                <TranslateProperty properties={[{key: 'placeholder', value: 'categoryName'}]}>
                    <Input
                        className="stg-input"
                        maxLength={150}
                        type="text"
                        value={newCategory}
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                    />
                </TranslateProperty>

                <BlueButton
                    size="md"
                    width={'120px'}
                    onClick={handleAddCategory}
                    disabled={!newCategory.trim()}
                >
                    <Translate text={'add'}/>
                </BlueButton>
            </div>

            {categories.length > 0 &&
                <div className="stg-list stg-scroll" style={{marginTop: '16px'}}>
                    {categories.map((category, index) => (
                        <div
                            key={category.id || category.name}
                            className={'stg-row ' + (visibleCategories[category.name] ? '' : 'off')}
                        >
                            <span className="stg-row__text">{category.name}</span>

                            <div className="stg-row__actions">
                                <Switch
                                    checked={visibleCategories[category.name] || false}
                                    onChange={() => toggleCategoryVisibility(category.name, category.id)}
                                />
                                <Tooltip text="remove" deltaY={-7}>
                                    <DestructiveButton
                                        type="button"
                                        variant="outline"
                                        size="sm"
                                        iconOnly
                                        width="32px"
                                        onClick={() => handleDeleteCategory(index, category.name)}
                                    >
                                        <DeleteIcon width={18} height={18} stroke="currentColor"/>
                                    </DestructiveButton>
                                </Tooltip>
                            </div>
                        </div>
                    ))}
                </div>
            }
        </div>
    </div>
);

export default Categories;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/resources/categories/Categories.jsx